"use client";
import { ResponsivePie } from "@nivo/pie";
import { nivo_theme } from "../charts/nivo-theme";
import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";

export default function EtfSectorChart({ symbol }: { symbol: string }) {
  const [etf_info] = trpcApi.stock.get_etf_info.useSuspenseQuery({
    symbol: symbol,
  });

  if (!etf_info || !etf_info.sectorsList.length)
    return <p className="text-muted-foreground">No sectors info available</p>;

  return (
    <div className="h-72 lg:h-96">
      <ResponsivePie /* or Pie for fixed dimensions */
        data={etf_info.sectorsList
          .sort((a, b) => a.industry.length - b.industry.length)
          .map((sector) => ({
            id: sector.industry,
            value: sector.exposure,
          }))}
        colors={[1, 2, 3, 4, 5].map((x) => `var(--chart-${x})`)}
        theme={nivo_theme}
        arcLabelsTextColor="var(--foreground)"
        arcLinkLabelsTextColor="var(--foreground)"
        margin={{
          top: 40,
          right: 100,
          bottom: 40,
          left: 145,
        }}
        tooltip={(d) => (
          <div className="bg-card text-card-foreground p-2 rounded-sm whitespace-nowrap flex items-center gap-2">
            <div
              className="w-4 h-4 rounded-xs"
              style={{
                backgroundColor: d.datum.color,
              }}
            />
            <b>{d.datum.label.toString().trim()}</b> {d.datum.data.value}%
          </div>
        )}
        valueFormat={(data) => data.toFixed(1) + "%"}
        innerRadius={0.5}
        padAngle={0.6}
        cornerRadius={2}
        activeOuterRadiusOffset={8}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsThickness={2}
        arcLabelsSkipAngle={10}
      />
    </div>
  );
}
